import * as toastr from 'toastr';
import {ACTION_TYPES, createAction} from "../actions";
import {call, put, takeEvery} from 'redux-saga/effects'
import {createEntity} from "../../http/createEntity";
import {getGeoType} from "../../utils/getGeoType";

export function* createEntitySaga () {
    yield takeEvery(ACTION_TYPES.CREATE_ENTITY, _createEntity);
}

function* _createEntity (action: any) {
    const payload: {feature: any, type: string, patch: {[key: string]: string}} = action.payload;
    try {
        const {type, patch, feature} = payload;
        const geoType = getGeoType(feature);
        patch.geoType = geoType;
        const entity = yield call(createEntity, patch);
        const fullUid = entity.fullUid;
        yield put(createAction(ACTION_TYPES.CREATE_FEATURE, {geoType, type, fullUid, feature, entity}));

        yield put(createAction(ACTION_TYPES.CREATE_ENTITY_SUCCESS, {
            fullUid, type, patch: entity
        }));
    } catch (error) {
        toastr.error('Error creating entity - Please try again');
        yield put(createAction(ACTION_TYPES.CREATE_ENTITY_ERROR, {error}));
    }
}
